import { ReactComponent as QraftLogoSvg } from "./qraftLogo.svg";

export default function QraftLogo() {
  return <QraftLogoSvg width="76px" height="17px" />;
}
